{
	"call_state": {
		"closed": "Chiuso",
		"draft": "In bozza",
		"open": "Aperto",
		"published": "Pubblicato"
	},
	"columns": {
		"call": "Bando",
		"city": "Città",
		"more_sites_one": "+{{count}} sede",
		"more_sites_other": "+{{count}} sedi",
		"next_year_ready": "{{year}} da aprire",
		"seats": "Posti"
	},
	"deactivated": {
		"badge": "Disattivata",
		"description": "Non è visibile sul portale e i gestori possono consultarla ma non modificarla.",
		"title": "Struttura disattivata"
	},
	"deactivation": {
		"blockers": {
			"call_in_progress": "un bando è pubblicato o aperto",
			"call_year_not_past": "il bando chiuso è dell'anno accademico in corso",
			"offers_pending": "ci sono offerte in attesa di risposta",
			"rooms_pending": "ci sono camere da proporre o confermare",
			"verifications_pending": "ci sono verifiche da completare"
		},
		"button": "Disattiva struttura",
		"confirm": "Disattiva",
		"description": "La struttura esce dal portale: la sua pagina e la sua graduatoria pubblica non sono più visibili e gli studenti non la trovano più tra i preferiti. I gestori possono solo consultarla. Non si cancella nulla e puoi riattivarla quando vuoi.",
		"done": "Struttura disattivata.",
		"not_possible": "La struttura non si può ancora disattivare",
		"title": "Disattivare la struttura?"
	},
	"detail": {
		"breadcrumb": "Struttura",
		"error": "Non è stato possibile caricare la struttura. Ricarica la pagina.",
		"next_call_note": "Le modifiche valgono per il prossimo bando: il bando {{year}} resta com'è. I dati del contratto e i posti ammessi a finanziamento di quel bando si correggono nella sua pagina.",
		"no_changes": "Nessun dato è cambiato.",
		"not_found": "Questa struttura non esiste.",
		"save": "Salva i dati",
		"saved": "Dati salvati."
	},
	"dsu_rate": {
		"button": "Tariffa DSU: {{single}} · {{double}}",
		"button_missing": "Imposta la tariffa DSU",
		"description": "La tariffa mensile della quota 30%, la stessa per tutte le strutture: è quella che il bando dell'organismo DSU fissa per il territorio. Le strutture con il bando in bozza la ricevono subito; i bandi già pubblicati tengono quella con cui sono usciti. Senza, nessun bando si pubblica.",
		"save": "Salva la tariffa",
		"saved": "Tariffa DSU salvata.",
		"title": "Tariffa DSU"
	},
	"empty": "Nessuna struttura. Crea la prima con \"Nuova struttura\".",
	"errors": {
		"double_beds_odd": "I posti in camera doppia delle sedi devono essere pari: ogni doppia ha due posti. Correggili nelle sedi.",
		"duplicate_entries": "Una voce compare più di una volta: lasciane una sola.",
		"equipped_below_minimum": "Servono almeno {{minimum}} posti attrezzati per studenti con disabilità su {{total}} (5%), sommando le sedi: ora sono {{equipped}}.",
		"funded_above_total": "I posti finanziati non possono essere più dei posti totali ({{total}}): correggi il numero.",
		"iban_invalid": "L'IBAN non è valido: controlla le cifre e il paese.",
		"institution_unknown": "Questo ateneo non è nel catalogo: scegli solo tra quelli elencati.",
		"link_not_https": "Il link deve cominciare con https://.",
		"no_seats": "La struttura deve avere almeno un posto: scrivi i posti delle quote.",
		"q30_below_minimum": "La quota 30% deve avere almeno {{minimum}} posti su {{total}}: aggiungi posti alla quota 30%.",
		"rate_not_positive": "L'importo deve essere maggiore di zero.",
		"rate_required": "Ci sono posti di questo tipo: scrivi la tariffa.",
		"rate_too_low": "L'importo mensile non può essere sotto i 50,00 €: controlla di averlo scritto in euro.",
		"required": "Da compilare prima di pubblicare.",
		"site_bathrooms_required": "Nella sede {{site}} manca il numero dei servizi igienici: scrivilo prima di pubblicare.",
		"site_double_beds_odd": "Nella sede {{site}} i posti in camera doppia devono essere pari: correggi il numero.",
		"site_equipped_above_beds": "Nella sede {{site}} i posti attrezzati superano i posti di quel tipo: correggi il numero.",
		"site_kitchens_required": "Nella sede {{site}} manca il numero delle cucine: scrivilo prima di pubblicare.",
		"site_typology_required": "Nella sede {{site}} manca la tipologia: sceglila prima di pubblicare.",
		"sites_beds_mismatch": "La quota 30% chiede {{expectedSingle}} singole e {{expectedDouble}} doppie, ma le sedi ne hanno {{single}} e {{double}}: correggi la quota 30% o i posti delle sedi.",
		"sites_count_invalid": "La struttura ha da 1 a 3 sedi.",
		"text_not_printable": "Questo testo contiene caratteri che il documento non sa stampare ({{characters}}): scrivilo con lettere latine e segni comuni."
	},
	"fields": {
		"admittedInstitutions": "Atenei ammessi",
		"bankAccountHolder": "Intestatario del conto",
		"callLinkUrl": "Link al bando sul sito del gestore",
		"contractSigningDays": "Giorni per firmare il contratto",
		"contractSigningInstructions": "Dove e come si firma il contratto",
		"dataControllerName": "Titolare del trattamento",
		"depositInstructions": "Come si versa il deposito cauzionale",
		"dpoContact": "Responsabile della protezione dei dati (DPO)",
		"fundedBeds": "Posti ammessi a finanziamento",
		"grantDecree": "Decreto di concessione",
		"iban": "IBAN",
		"infoEmail": "Email per informazioni",
		"name": "Nome della struttura",
		"operatorLegalName": "Ragione sociale del beneficiario DM 481",
		"pecAddress": "Indirizzo PEC della struttura",
		"q30DoubleBeds": "Quota 30%: posti in camera doppia",
		"q30SingleBeds": "Quota 30%: posti in camera singola",
		"q70DoubleBeds": "Quota 70%: posti in camera doppia",
		"q70DoubleRateCents": "Quota 70%: tariffa mensile doppia",
		"q70SingleBeds": "Quota 70%: posti in camera singola",
		"q70SingleRateCents": "Quota 70%: tariffa mensile singola",
		"services": "Servizi compresi nella tariffa",
		"sites": "Sedi"
	},
	"form": {
		"email_invalid": "Scrivi un indirizzo email completo, per esempio info@residenza.it.",
		"fix_fields": "Alcuni dati non vanno bene: correggi i campi segnalati.",
		"format_invalid": "Il formato non è valido.",
		"maximum": "Il valore massimo è {{maximum}}.",
		"minimum": "Il valore minimo è {{minimum}}.",
		"number_required": "Scrivi un numero intero.",
		"rate_maximum": "La tariffa non può superare {{maximum}} al mese.",
		"required": "Compila questo campo.",
		"required_for_call": "(serve per il bando)",
		"required_legend": "= serve per pubblicare il bando.",
		"tab_has_errors": "contiene campi da correggere",
		"tab_to_fill": "da compilare, non blocca il bando",
		"too_long": "Al massimo {{maximum}} caratteri.",
		"url_invalid": "Scrivi l'indirizzo completo, con https://."
	},
	"groups": {
		"beds": "Posti",
		"quota30": "Quota 30%",
		"quota70": "Quota 70%"
	},
	"hints": {
		"address_attribution": "Suggerimenti di Google",
		"address_position": "Scegli l'indirizzo dall'elenco di Google: così la struttura compare sulla mappa della pagina pubblica.",
		"admittedInstitutions": "Gli atenei che il bando nomina: in cima quelli con una sede nella città della struttura.",
		"contractSigningDays": "Dall'accettazione dell'offerta.",
		"double_beds": "Due posti per camera.",
		"double_beds_odd": "I posti in camera doppia delle sedi sono dispari: ogni doppia ha due posti, correggili nelle sedi.",
		"double_rooms_one": "{{count}} camera doppia in tutto, nelle sedi",
		"double_rooms_other": "{{count}} camere doppie in tutto, nelle sedi",
		"dpoContact": "Per esempio: \"Mario Rossi, dpo@gestore.it\".",
		"fundedBeds": "I posti finanziati dal DM 481: la quota DSU durante l'anno deve coprirne almeno il 30%.",
		"grantDecree": "Numero e data del decreto, per esempio \"DD n. 123 del 1 luglio 2026\".",
		"infoEmail": "Gli studenti scrivono qui per informazioni. Se lo lasci vuoto, usiamo la PEC della struttura.",
		"pecAddress": "Le domande degli studenti arrivano a questo indirizzo.",
		"q30_over_sites": "La quota 30% ha più posti di quelli delle sedi (singole: {{single}}, doppie: {{double}}). Si salva lo stesso, ma il bando non si pubblica finché i numeri non tornano.",
		"seats_summary": "{{total}} posti in tutto, presi dalle sedi ({{single}} singole e {{double}} doppie). Alla quota 30% ne vanno {{q30}} ({{percent}}%), il resto è la quota 70%."
	},
	"institutions": {
		"empty": "Nessun ateneo nel catalogo. Carica i dati con il comando geo:import-institutions.",
		"load_failed": "Non riesco a caricare l'elenco degli atenei.",
		"loading": "Carico gli atenei…",
		"no_match": "Nessun ateneo con questo nome.",
		"not_listed": "Ateneo {{code}} (non più nel catalogo)",
		"retry": "Riprova",
		"search": "Cerca un ateneo…"
	},
	"issues": {
		"site": {
			"bathrooms_required": "manca il numero dei servizi igienici",
			"double_beds_odd": "i posti in camera doppia devono essere pari",
			"equipped_above_beds": "i posti attrezzati superano i posti di quel tipo",
			"kitchens_required": "manca il numero delle cucine",
			"typology_required": "manca la tipologia"
		},
		"title": "Da sistemare prima di pubblicare"
	},
	"location": {
		"current": "Posizione salvata: {{latitude}}, {{longitude}}.",
		"description": "La vetrina mostra la struttura su una mappa Google. Cerca l'indirizzo, controlla il punto sulla mappa e salva. La posizione si cambia in ogni momento, anche a bando pubblicato.",
		"discard": "Annulla",
		"map_label": "Mappa della posizione di {{name}}",
		"no_key": "La mappa di Google non è attiva in questo ambiente: manca la chiave del browser (VITE_GOOGLE_MAPS_API_KEY).",
		"none": "Nessuna posizione indicata: la struttura non compare sulla mappa della vetrina.",
		"pending": "Da salvare: {{address}}.",
		"remove": "Togli dalla mappa",
		"removed": "La struttura non è più sulla mappa.",
		"save": "Salva posizione",
		"saved": "Posizione salvata.",
		"search_failed": "Non riesco a caricare la ricerca di Google. Ricarica la pagina.",
		"search_label": "Cerca l'indirizzo",
		"title": "Posizione sulla mappa",
		"title_site": "Posizione sulla mappa: sede {{number}}, {{name}}"
	},
	"mailbox_test": {
		"check": "Invia un'email di controllo",
		"code": "Codice di verifica",
		"confirmed": "Confermato da {{name}} il {{date}}",
		"delivery": "Consegna",
		"delivery_states": {
			"delivered": "Consegnata",
			"refused": "Respinta dalla casella",
			"sending": "In invio"
		},
		"error": "Non riesco a leggere lo stato dell'email di prova. Ricarica la pagina.",
		"no_address": "Manca l'indirizzo PEC del bando: inseriscilo nei dati prima di inviare la prova.",
		"none": "Nessuna email di prova inviata a {{address}}. Il bando si pubblica solo dopo che il gestore ha letto il codice nella PEC e lo ha confermato.",
		"published_note": "Il bando è pubblicato: la conferma che lo ha pubblicato resta valida. Una nuova email serve solo a controllare che la casella riceva.",
		"refused_hint": "La casella ha respinto l'email. Il gestore controlla che accetti la posta normale, poi si invia una nuova prova.",
		"send": "Invia l'email di prova",
		"send_again": "Invia una nuova email di prova",
		"sent": "Email di prova inviata. Lo stato si aggiorna da solo.",
		"sent_on": "A {{address}}, il {{date}}",
		"sent_to": "Invio",
		"title": "Email di prova",
		"waiting_code_one": "In attesa della conferma del gestore. Resta {{count}} tentativo.",
		"waiting_code_other": "In attesa della conferma del gestore. Restano {{count}} tentativi."
	},
	"managers": {
		"actions": "Comandi",
		"add": "Aggiungi gestore",
		"add_description": "Ogni persona ha il suo account. Se l'indirizzo è già di un gestore, il suo account si collega anche a questa struttura; altrimenti arriva per email un invito valido 7 giorni per scegliere la password.",
		"add_title": "Aggiungi un gestore",
		"already_assigned": "Questa persona gestisce già questa struttura.",
		"disable": "Disattiva account",
		"disable_all_description_one": "Disattiva l'accesso a tutte le strutture di questa persona, questa compresa.",
		"disable_all_description_other": "Disattiva l'accesso a tutte e {{count}} le strutture di questa persona, questa compresa. Per toglierla solo da qui usa \"Togli da questa struttura\".",
		"disable_all_title": "Disattivare l'account di {{name}}?",
		"disabled": "Account disattivato: le sue sessioni sono chiuse.",
		"email": "Email",
		"email_in_use": "Questo indirizzo è di un admin generale: usa l'indirizzo personale del gestore.",
		"empty": "Nessun account: aggiungi il primo gestore.",
		"enable": "Riattiva",
		"enabled": "Account riattivato.",
		"error": "Non riesco a caricare gli account. Ricarica la pagina.",
		"first_name": "Nome",
		"invite_resent": "Invito inviato di nuovo.",
		"invited": "Invito inviato a {{email}}.",
		"invited_at": "Invitato il",
		"last_name": "Cognome",
		"last_sign_in": "Ultimo accesso",
		"linked": "{{name}} ha già un account: ora gestisce anche questa struttura e riceve un'email di avviso.",
		"manager_disabled": "L'account di questa persona è disattivato: riattivalo da una delle sue strutture, poi aggiungilo qui.",
		"name": "Nome e cognome",
		"never": "Mai",
		"open_menu": "Comandi per {{name}}",
		"other_residences_one": "Gestisce anche un'altra struttura",
		"other_residences_other": "Gestisce anche altre {{count}} strutture",
		"remove": "Togli da questa struttura",
		"removed": "{{name}} non gestisce più questa struttura.",
		"resend_invite": "Invia di nuovo l'invito",
		"status": "Stato",
		"statuses": {
			"active": "Attivo",
			"disabled": "Disattivato",
			"pending": "Invito in attesa"
		},
		"submit": "Aggiungi",
		"title": "Account dei gestori"
	},
	"new": {
		"button": "Nuova struttura",
		"invite_failed": "Struttura creata, ma l'email al gestore non è partita: inviala di nuovo dalla scheda Gestori.",
		"invited": "Struttura creata: invito inviato a {{email}}.",
		"linked": "Struttura creata: {{email}} ha già un account, ora gestisce anche questa struttura e riceve un'email di avviso.",
		"manager_hint": "Riceve l'invito per email e completa lui tutti i dati della struttura e del bando.",
		"manager_title": "Gestore",
		"page_title": "Nuova struttura",
		"residence_title": "Struttura",
		"submit": "Crea la struttura e invita il gestore"
	},
	"next_year": {
		"button": "Apri il bando {{year}}",
		"confirm": "Apri il bando",
		"description": "Il bando nasce in bozza con i dati attuali della struttura. Il gestore lo prepara, ma lo pubblica solo dopo aver fermato le domande sui posti rimasti dell'anno prima.",
		"opened": "Bando {{year}} aperto in bozza.",
		"title": "Aprire il bando {{year}}?"
	},
	"page_title": "Strutture",
	"photos": {
		"add": "Aggiungi foto",
		"alt": "Foto {{n}} di {{name}}",
		"cover": "Copertina",
		"empty_hint": "Senza foto, gli studenti vedono un'illustrazione. Carica fino a 10 foto: la prima è la copertina.",
		"hint_one": "{{count}} foto su {{max}}. La prima è la copertina: trascina le foto per cambiare l'ordine.",
		"hint_other": "{{count}} foto su {{max}}. La prima è la copertina: trascina le foto per cambiare l'ordine.",
		"invalid_type": "Usa foto JPEG, PNG o WebP.",
		"limit": "Una struttura mostra al massimo 10 foto.",
		"make_cover": "Usa come copertina",
		"menu": "Azioni sulla foto {{n}}",
		"move_earlier": "Sposta prima",
		"move_later": "Sposta dopo",
		"placeholder_note": "Questa è l'immagine che compare finché non carichi una foto.",
		"remove": "Elimina",
		"too_large": "Ogni foto può pesare al massimo 10 MB.",
		"upload_failed": "Una foto non è stata caricata: riprova."
	},
	"reactivation": {
		"button": "Riattiva",
		"done": "Struttura riattivata."
	},
	"references": {
		"dsu_missing": "La tariffa DSU non è ancora stata impostata dall'admin generale: senza, il bando non si pubblica."
	},
	"search_placeholder": "Cerca per nome, città o indirizzo della pagina",
	"seat_fields": {
		"double_beds": "Posti in camera doppia",
		"double_rate": "Tariffa mensile doppia",
		"single_beds": "Posti in camera singola",
		"single_rate": "Tariffa mensile singola"
	},
	"site_fields": {
		"address": "Indirizzo",
		"bathroomsCount": "Servizi igienici",
		"bathroomsDescription": "Descrizione dei servizi igienici",
		"city": "Città",
		"doubleBeds": "Posti in camera doppia",
		"equippedBathroomsDescription": "Servizi igienici attrezzati",
		"equippedDoubleBeds": "Posti attrezzati in camera doppia",
		"equippedKitchensDescription": "Cucine attrezzate",
		"equippedOtherServicesDescription": "Altri servizi attrezzati",
		"equippedSingleBeds": "Posti attrezzati in camera singola",
		"kitchensCount": "Cucine",
		"kitchensDescription": "Descrizione delle cucine",
		"name": "Nome della residenza",
		"otherServicesDescription": "Altri servizi",
		"singleBeds": "Posti in camera singola",
		"typology": "Tipologia"
	},
	"site_hints": {
		"other_services": "Con il numero, per esempio \"2 aule studio, 1 lavanderia\". Se vuoto il bando scrive \"nessuno\"."
	},
	"site_placeholders": {
		"address": "Via e numero civico",
		"bathrooms_description": "Per esempio: 40 bagni privati, 2 condivisi",
		"kitchens_description": "Per esempio: 1 cucina comune al piano terra"
	},
	"sites": {
		"add": "Aggiungi una sede",
		"equipped_title": "Alloggi attrezzati per studenti con disabilità",
		"has_errors": "Da correggere",
		"incomplete": "Da completare",
		"remove": "Togli la sede {{number}}",
		"rooms_title": "Camere e servizi",
		"summary_seats": "{{single}} singole, {{double}} doppie",
		"title": "Sede {{number}}",
		"totals": "Totale delle sedi: {{single}} posti in singola e {{double}} in doppia. In Posti e tariffe scegli quanti vanno alla quota 30%.",
		"where_title": "Dove si trova"
	},
	"tabs": {
		"contract": "Contratto e pagamenti",
		"general": "Dati generali",
		"identity": "Anagrafica",
		"location": "Posizione",
		"managers": "Gestori",
		"pec": "PEC",
		"photos": "Foto",
		"seats": "Posti e tariffe",
		"services": "Servizi",
		"sites": "Sedi"
	},
	"typology": {
		"choose": "Scegli la tipologia",
		"hotel": "Ad albergo",
		"integrated_units": "A nuclei integrati",
		"mini_apartments": "A minialloggi",
		"mixed": "Mista (due o più tipologie)",
		"other": "Altra tipologia",
		"other_placeholder": "Scrivi la tipologia, come la stampa il bando"
	}
}
